export default __webpack_public_path__ + "static/media/Hop.4b77c9e3.svg";